import React, { Component } from 'react';
import PropTypes from 'prop-types';

import DropdownButton from './DropdownButton';
import DropdownItem from './DropdownItem';
import DropdownContext from './DropdownContext';

import stylesheet from './Dropdown.module.css';

class Dropdown extends Component {
  state = {
    isOpen: false,
  };

  dropdown = React.createRef();
  container = React.createRef();

  componentDidMount() {
    document.addEventListener('mousedown', this.handleOutsideClick);
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick);
    window.removeEventListener('resize', this.handleResize);
  }

  calculateDropdownBoundaries() {
    const buffer = 10;

    const dropdownRect = this.dropdown.current.getBoundingClientRect();
    const containerRect = this.container.current.getBoundingClientRect();

    const maxHeight = window.innerHeight - containerRect.top - buffer;
    const maxRight = dropdownRect.left + containerRect.width + buffer;

    const inlineStyles = {
      maxHeight: `${maxHeight}px`,
      marginLeft:
        window.innerWidth < maxRight
          ? `-${Math.floor(containerRect.width - dropdownRect.width)}px`
          : 'auto',
    };

    Object.assign(this.container.current.style, inlineStyles);
  }

  handleToggle = () => {
    this.setState(
      {
        isOpen: !this.state.isOpen,
      },
      () => {
        if (this.state.isOpen) {
          this.handleResize();
        }
      },
    );
  };

  handleOutsideClick = e => {
    if (this.state.isOpen && !this.dropdown.current.contains(e.target)) {
      this.handleToggle();
    }
  };

  handleResize = () => {
    if (this.state.isOpen) {
      this.calculateDropdownBoundaries();
    }
  };

  render() {
    return (
      <DropdownContext.Provider value={this.handleToggle}>
        <nav className={stylesheet.root} ref={this.dropdown}>
          <button
            aria-label={this.props.label}
            className={stylesheet.toggleButton}
            onClick={this.handleToggle}
          >
            {this.props.label}
          </button>
          {this.state.isOpen && (
            <ul className={stylesheet.container} ref={this.container}>
              {this.props.children}
            </ul>
          )}
        </nav>
      </DropdownContext.Provider>
    );
  }
}

Dropdown.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

Dropdown.Button = DropdownButton;
Dropdown.Item = DropdownItem;

export default Dropdown;
